import { ButtonSize, ButtonType, ButtonVariant } from 'components/core';

/** A small outline button for the builder. It sits inside the editor's form, so it must never submit it. */
export const OUTLINE_SMALL = {
  size: ButtonSize.small,
  type: ButtonType.secondary,
  variant: ButtonVariant.outline,
  htmlType: 'button' as const,
};
